import React, { Fragment, useEffect, useState } from "react";
import "./user.scss";
import { Table } from "react-bootstrap";
import { convertDate } from "../../utils/miscelleneous";
import Switch from "react-switch";
import { useDispatch, useSelector } from "react-redux";
import {
  getUsers,
  getUserSubscriptionPlan,
  updateSubscriptionPlan,
  resetUserList,
  addUser,
  changeStatus,
  getTenants,
  getTenantsProfile,
  updateTenantStatus,
  updateCredits,
  getSubscriptionPlans,
  getAllSubscriptionPlanOptions,
  createTenantSubscription,
  updateCandidateCredits,
} from "../../Redux/ActionCreators/userAction";
import Modal from "react-bootstrap/Modal";
import { BallBeat } from "../../Loader/loader";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { returnErrors } from "../../Redux/ActionCreators/errorAction";

export default function Users() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const rows = 25;

  // Use a single query state for both tabs
  const [query, setQuery] = useState("");
  // Use separate page states for each tab
  const [currentUserPage, setCurrentUserPage] = useState(1);
  const [currentTenantPage, setCurrentTenantPage] = useState(1);
  // Active tab: "user" or "tenant"
  const [activeTab, setActiveTab] = useState("user");

  // Other UI states
  const [isDetail, setIsDetail] = useState(false);
  const [detail, setDetail] = useState(null);
  const [isAddUser, setIsAddUser] = useState(false);
  const [name, setName] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const [nameError, setNameError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [actionTab, setActionTab] = useState(false);
  const [addCredits, setAddCredits] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [additionalCredit, setAdditionalCredit] = useState("");
  const [validTillDate, setValidTillDate] = useState("");
  const [modelMessage, setModalMessage] = useState(
    "User Plan Has Been Updated"
  );
  const [selectedPlanId, setSelectedPlanId] = useState("");
  const [planTestCredits, setPlanTestCredits] = useState(null);
  const [loading, setLoading] = useState(false);
  const [subscriptionPopup, setSubscriptionPopup] = useState(false);
  const [subscriptionError, setSubscriptionError] = useState(false);
  const [availablePlans, setAvailablePlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [currentTenantForSubscription, setCurrentTenantForSubscription] = useState(null);
  const [isEditingCandidateCredits, setIsEditingCandidateCredits] = useState(false);
  const [candidateCreditInput, setCandidateCreditInput] = useState(0);
  const [credits, setCredits] = useState(0);
  const [selectedPlanIdForSubscription, setSelectedPlanIdForSubscription] = useState("");
  const [featureCounts, setFeatureCounts] = useState({
    VOICE_CALL: 0,
    ASSESSMENT: 0,
    VIDEO_CALL: 0,
    candidate_count: 0,
  });

  
  
  // Destructure Redux state (make sure your reducer saves total count as total and totalTenant)
  const {
    isUserLoading,
    usersList,
    total,
    tenantUsers,
    subscriptionPlanList,
    totalTenant,
    tenantIndividualUser,
    selectedTenant,
  } = useSelector((state) => state.users);
  
  const details = JSON.parse(localStorage.getItem("profileDetails"));
  const isUsagePlan = selectedPlan?.plan_type === "usage";
  const isFixedPlan = selectedPlan?.plan_type === "fixed";
  const currentPlanType = selectedTenant?.data?.subscription_plan?.plan_type;
  const isUsageCurrentPlan = currentPlanType === "usage";

  const timerRef1 = React.useRef(null);
  const statusLockRef = React.useRef({});

  useEffect(() => {
    dispatch(resetUserList());
    if (activeTab === "user") {
      setCurrentUserPage(1);
      dispatch(getUsers(query, 1, rows));
    } else {
      setCurrentTenantPage(1);
      dispatch(getTenants(query, 1, rows));
    }
  }, [activeTab, dispatch, rows]);

  useEffect(() => {
    dispatch(getUserSubscriptionPlan());
  }, []);

  useEffect(() => {
    if (activeTab === "user") {
      dispatch(getUsers(query, currentUserPage, rows));
    }
  }, [activeTab, currentUserPage, dispatch, rows]);

  useEffect(() => {
    if (activeTab === "tenant") {
      dispatch(getTenants(query, currentTenantPage, rows));
    }
  }, [activeTab, currentTenantPage, dispatch, rows]);

  // --- Search functions ---
  const searchUser = (val) => {
    clearTimeout(timerRef1.current);
    setQuery(val);
    timerRef1.current = setTimeout(() => {
      dispatch(resetUserList());
      if (activeTab === "user") {
        setCurrentUserPage(1);
        dispatch(getUsers(val, 1, rows));
      }
    }, 800);
  };

  const searchTennant = (val) => {
    clearTimeout(timerRef1.current);
    setQuery(val);
    timerRef1.current = setTimeout(() => {
      dispatch(resetUserList());
      if (activeTab === "tenant") {
        setCurrentTenantPage(1);
        dispatch(getTenants(val, 1, rows));
      }
    }, 800);
  };

  const onTabChange = (tab) => {
    setActiveTab(tab);
  };

  const STATUS_CLICK_COOLDOWN = 1500;

  // --- Other handlers ---
  const handleChange = async (el, active) => {
    const userId = el.userID;

    if (statusLockRef.current[userId]) {
      return;
    }

    if (
      el?.roleName === "Admin" &&
      el?.isActive === 1 &&
      active === 1
    ) {
      setModalMessage("You cannot change admin status to inactive");
      setShowSuccessModal(true);
      return;
    }

    statusLockRef.current[userId] = true;

    const obj = {
      userId: el?.userID,
      statusId: active === 0 ? 1 : 0,
    };
    try {
      await dispatch(changeStatus(obj));
    } finally {
      // ⏱ unlock after fixed delay (NOT immediately)
      setTimeout(() => {
        delete statusLockRef.current[userId];
      }, STATUS_CLICK_COOLDOWN);
    }
  };

  const handleStatusChangeTenant = async (el, active) => {
    const obj = {
      userId: el?.userID,
      statusId: active === 0 ? 1 : 0,
    };
    setisLoading(true);
    setLoading(true);
    try {
      const response = await dispatch(updateTenantStatus(obj));
      if (response) {
        setModalMessage(`${el?.name} ${t("Status Has Been Updated")}`);
        setShowSuccessModal(true);
        setCurrentTenantPage(1);
        dispatch(getTenants(query, 1, rows));
      }
      setisLoading(false);
      setLoading(false);
    } catch (error) {
      setisLoading(false);
      setLoading(false);
    }
  };

  const changeName = (val) => {
    setName(val);
    setNameError("");
  };

  const changeEmail = (val) => {
    setEmail(val);
    setEmailError("");
  };

  const saveUser = async () => {
    const emailPattern = /\s/;
    if (name === "") {
      setNameError(t(`Name can't be empty`));
    } else if (email.trim() === "") {
      setEmailError(t(`Email can't be empty`));
    } else if (emailPattern.test(email)) {
      setEmailError(t(`Email can't contain spaces`));
    } else {
      setisLoading(true);
      const obj = {
        name: name.trim(),
        emailId: email.trim(),
      };
      const res = await dispatch(addUser(obj));
      if (res?.type === "ADD_USERS") {
        setIsAddUser(false);
        setName("");
        setEmail("");
        setCurrentUserPage(1);
        dispatch(getUsers("", 1, rows));
      }
      setisLoading(false);
    }
  };

  const handleSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const handleModal = () => {
    setName("");
    setNameError("");
    setEmail("");
    setEmailError("");
    setIsAddUser(false);
    setIsDetail(false);
    setSelectedPlanId("");
    setPlanTestCredits(null);
    setAdditionalCredit("");
    setValidTillDate("");
  };

  const openDetail = (el) => {
    setIsDetail(true);
    setDetail(el);
  };

  const copyLink = () => {
    const copyText = document.getElementById("pass")?.value;
    navigator.clipboard.writeText(copyText);
  };

  // !handle plan
  const handlePlanChange = (e) => {
    const selected = availablePlans.find(
      (p) => p.id === e.target.value
    );

    setSelectedPlan(selected);

    // Prefill total credits ONLY if usage plan
    if (selected?.plan_type === "usage") {
      setCredits(selected.total_credits ?? 0);
    } else {
      setCredits(0);
    }

    const selectedId = parseInt(e.target.value);
    setSelectedPlanId(selectedId);

    // Find the selected plan in the plans array
    const selectedPlan = subscriptionPlanList?.find(
      (plan) => plan.planId === selectedId
    );
    console.log("🚀 ~  selectedPlan: ", selectedPlan);
    console.log(subscriptionPlanList);

    // Extract testCredits from accessMatrix of the selected plan
    const testCredits = selectedPlan?.accessMatrix?.testCredits || "";
    setPlanTestCredits(testCredits);
  };

  const handleTestCreditsChange = (e) => {
    const newValue = parseInt(e.target.value);
    setPlanTestCredits(newValue);
  };

  const updateSubscriptionChange = async () => {
    const jsonObj = {
      tenantId: tenantIndividualUser?.tenantId,
      planId: selectedPlanId,
      testCredit: planTestCredits ?? tenantIndividualUser?.planTestCredit,
    };
    setisLoading(true);
    setLoading(true);
    try {
      const response = await dispatch(updateSubscriptionPlan(jsonObj));
      if (response) {
        setModalMessage(
          `${tenantIndividualUser?.name} ${t("Plan Has Been Updated")}`
        );
        setIsAddUser(false);
        setIsDetail(false);
        setShowSuccessModal(true);
        setCurrentTenantPage(1);
        dispatch(getTenants(query, 1, rows));
        setSelectedPlanId("");
        setPlanTestCredits(null);
      }
      setisLoading(false);
      setLoading(false);
    } catch (error) {
      setSelectedPlanId("");
      setisLoading(false);
      setLoading(false);
    }
  };

  const getTenantDetails = async (tenantDetail) => {
    setLoading(true);
    const tenantId = tenantDetail?.tenantId;
    const userID = tenantDetail?.userID;
    try {
      const response = await dispatch(getTenantsProfile(tenantId, userID));
      if (response) {
        setLoading(false);
        openDetail(tenantDetail);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleAddUsers = () => {
    if (details?.accessMatrix?.canAddUser) {
      setIsAddUser(true);
    } else {
      setModalMessage(t("Please upgrade your plan to add users"));
      setShowSuccessModal(true);
    }
  };

  const handleAddCredits = async () => {
    await setLoading(true);
    if (!additionalCredit) {
      returnErrors(dispatch, "Please fill credits", 400);
    } else if (!validTillDate) {
      returnErrors(dispatch, "Please fill Valid till date", 400);
    } else {
      const payload = {
        tenantId: tenantIndividualUser?.tenantId,
        credit: parseInt(additionalCredit),
        validTillDate: validTillDate,
      };

      const response = await dispatch(updateCredits(payload));
      if (response?.type === "ADD_CREDITS") {
        setAddCredits(false);
        handleModal();
        setLoading(false);
      }
    }
    await setLoading(false);
  };

  const getSubscriptionPlan = async (tenantDetail) => {
    setLoading(true);
    setCurrentTenantForSubscription(tenantDetail);

    const tenantId = tenantDetail?.tenantId;

    setFeatureCounts({
      VOICE_CALL: 0,
      VIDEO_CALL: 0,
      ASSESSMENT: 0,
      candidate_count: 0,
    });

    try {
      const response = await dispatch(getSubscriptionPlans(tenantId));

      if (response?.status === 200) {
        setSubscriptionError(false);
        setSubscriptionPopup(true);
      }
    } catch (error) {

      const status = error?.parsedStatus;

      if (status === 404) {
        try {
          const plansRes = await dispatch(getAllSubscriptionPlanOptions());

          if (plansRes?.status === 200) {
            setAvailablePlans(plansRes.data?.data || []);
            setSubscriptionError(true);
            setSubscriptionPopup(true);
          }
        } catch (innerErr) {
          console.error("[user.js] ❌ Failed to fetch available plans:", innerErr);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handleFeatureCountChange = (type, value) => {
    const newValue = Math.max(0, Number(value));
    setFeatureCounts((prev) => ({
      ...prev,
      [type]: newValue,
    }));
  };

  const handleAddSubscription = async (tenantDetail) => {
    if (!selectedPlan || !tenantDetail?.tenantId) {
      return;
    }

    const tenantId = tenantDetail?.tenantId;

    const payload = {
      plan_id: selectedPlan.id,
      tenant_id: tenantId,
      referece_type_id: "656ba867-5c41-4234-85bd-bd62cd2dcf10",
    };

    if (isFixedPlan) {
      payload.voice_count = featureCounts.VOICE_CALL;
      payload.video_count = featureCounts.VIDEO_CALL;
      payload.assessment_count = featureCounts.ASSESSMENT;
      payload.candidate_count = featureCounts.candidate_count;
    }

    if (isUsagePlan) {
      payload.credits = credits;
      payload.voice_deduct_quantity = featureCounts.VOICE_CALL;
      payload.video_deduct_quantity = featureCounts.VIDEO_CALL;
      payload.assessment_deduct_quantity = featureCounts.ASSESSMENT;
      payload.candidate_deduct_quantity = featureCounts.candidate_count;
    }

    try {
      setLoading(true);
      await dispatch(createTenantSubscription(payload));
      setSubscriptionPopup(false);
    } catch (error) {
      console.error("Subscription creation failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (val) => {
    clearTimeout(timerRef1.current);
    setQuery(val);

    // Condition: Only trigger when 3+ letters OR cleared
    if (val.length >= 3 || val.length === 0) {
      timerRef1.current = setTimeout(() => {
        dispatch(resetUserList());

        if (activeTab === "user") {
          setCurrentUserPage(1);
          dispatch(getUsers(val, 1, rows));
        } else {
          setCurrentTenantPage(1);
          dispatch(getTenants(val, 1, rows));
        }
      }, 700);
    }
  };

  // --- Pagination functions ---
  const paginateUsers = (pageNumber) => {
    const totalPages = Math.ceil(total / rows);
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentUserPage(pageNumber);
  };

  const paginateTenants = (pageNumber) => {
    const totalPages = Math.ceil(totalTenant / rows);
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentTenantPage(pageNumber);
  };

  // --- Pagination Component ---
  const Pagination = ({
    currentPage,
    totalPages,
    paginate,
    indexOfFirst,
    indexOfLast,
    total,
  }) => {
    const getPageNumbers = () => {
      if (totalPages <= 4) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
      } else if (currentPage <= 3) {
        return [1, 2, 3, "...", totalPages];
      } else if (currentPage >= totalPages - 2) {
        return [1, "...", totalPages - 2, totalPages - 1, totalPages];
      } else {
        return [
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages,
        ];
      }
    };

    return (
      <div className="pagination">
        <div className="pagination-info">
          {total > 0 ? (
            <span>
              Showing <strong>{indexOfFirst + 1}</strong>-
              <strong>{indexOfLast}</strong> of <strong>{total}</strong>
            </span>
          ) : (
            <span>Showing 0-0 of 0</span>
          )}
        </div>
        <div className="pagination-buttons">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <img src="/images/leftarrow-icon.svg" alt="Previous" />
          </button>
          {getPageNumbers().map((page, index) => (
            <button
              key={index}
              onClick={() => (page === "..." ? null : paginate(page))}
              className={currentPage === page ? "active" : ""}
              disabled={page === "..."}
            >
              {page}
            </button>
          ))}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            <img
              src="/images/leftarrow-icon.svg"
              alt="Next"
              style={{ transform: "rotate(180deg)" }}
            />
          </button>
        </div>
      </div>
    );
  };

  const handleCandidateCreditsSave = async (subscriptionId, newValue) => {
    try {
      const response = await dispatch(updateCandidateCredits(subscriptionId, { candidate_count: newValue }));

      if (response?.status === 200) {
        dispatch(getSubscriptionPlans(currentTenantForSubscription?.tenantId));
        setIsEditingCandidateCredits(false);
        returnErrors(dispatch, "Credits updated successfully", 200);
      } else {
        returnErrors(dispatch, "Failed to update credits", 400);
      }
    } catch (error) {
      returnErrors(dispatch, "Failed to update credits", 400);
    }
  };

  const resetSubscriptionPopup = () => {
    setSelectedPlan(null);
    setSelectedPlanIdForSubscription("");
    setCredits(0);
    setIsEditingCandidateCredits(false);;

    setFeatureCounts({
      VOICE_CALL: 0,
      ASSESSMENT: 0,
      VIDEO_CALL: 0,
      candidate_count: 0,
    });
  };

  return (
    <div className="users-holder">
      {details?.tenentId === "-1" && details?.roleId === "1" ? (
        <Fragment>
          <div className="users-header">
            <h2>{t("Users", { ns: "profile" })}</h2>
            {activeTab === "user" ? (
              <div className="d-flex align-items-center flex-wrap">
                <div className="has-search">
                  <span className="form-control-feedback">
                    <img src="/images/search.svg" alt="" width={12} />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    value={query}
                    placeholder={t("Search for a user", { ns: "profile" })}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                </div>
                &nbsp;&nbsp;
                <button className="add-btn" onClick={handleAddUsers}>
                  {t("ADD USERS", { ns: "profile" })}
                </button>
              </div>
            ) : (
              <div className="d-flex align-items-center flex-wrap">
                <div className="has-search">
                  <span className="form-control-feedback">
                    <img src="/images/search.svg" alt="" width={12} />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    value={query}
                    placeholder={t("Search for a tenant", { ns: "profile" })}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                </div>
              </div>
            )}
            <div className="user-btns mt-4 d-flex align-items-center">
              <button
                className={activeTab === "user" ? "active" : ""}
                onClick={() => onTabChange("user")}
              >
                {t("Users", { ns: "profile" })}
              </button>
              &nbsp;&nbsp;
              <button
                className={activeTab === "tenant" ? "active" : ""}
                onClick={() => onTabChange("tenant")}
              >
                {t("Tenants", { ns: "profile" })}
              </button>
            </div>
          </div>
          {activeTab === "user" ? (
            <div className="table-admin">
              <Table responsive className="assessment-table">
                <thead>
                  <tr>
                    <th>{t("Name", { ns: "profile" })}</th>
                    <th>{t("Email", { ns: "profile" })}</th>
                    <th>{t("Role", { ns: "profile" })}</th>
                    <th>{t("Joined", { ns: "profile" })}</th>
                    <th>{t("Status", { ns: "profile" })}</th>
                  </tr>
                </thead>
                <tbody className="table-body">
                  {isUserLoading
                    ? "Loading"
                    : usersList &&
                      usersList.map((el) => (
                        <tr key={el.userID}>
                          <td>
                            <strong>{el.name}</strong>
                          </td>
                          <td>{el.emailId}</td>
                          <td>{el.roleName}</td>
                          <td>{convertDate(new Date())}</td>
                          <td>
                            <p
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleChange(el, el.isActive);
                              }}
                            >
                              <Switch
                                onChange={(e) => {}}
                                width={30}
                                height={16}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                onColor="#F75891"
                                checked={el.isActive === 1}
                                disabled={!!statusLockRef.current[el.userID]}
                              />
                              &nbsp;&nbsp;
                              <br />
                              {el.isActive === 1 ? "Active" : "Inactive"}
                            </p>
                          </td>
                        </tr>
                      ))}
                </tbody>
              </Table>
              <Pagination
                currentPage={currentUserPage}
                totalPages={Math.ceil(total / rows)}
                paginate={paginateUsers}
                indexOfFirst={(currentUserPage - 1) * rows}
                indexOfLast={Math.min(currentUserPage * rows, total)}
                total={total}
              />
            </div>
          ) : (
            <div className="table-admin">
              <Table responsive className="assessment-table">
                <thead>
                  <tr>
                    <th>{t("Name", { ns: "profile" })}</th>
                    <th>{t("Email", { ns: "profile" })}</th>
                    <th>{t("Joined", { ns: "profile" })}</th>
                    <th>{t("Plan", { ns: "profile" })}</th>
                    <th>{t("Status", { ns: "profile" })}</th>
                    <th style={{ textAlign: "center" }}>
                      {t("Action", { ns: "profile" })}
                    </th>
                  </tr>
                </thead>
                <tbody className="table-body">
                  {isUserLoading
                    ? "Loading"
                    : tenantUsers &&
                      tenantUsers.map((el) => (
                        <tr key={el.userID}>
                          <td>
                            <strong>{el.name}</strong>
                          </td>
                          <td>{el.emailId}</td>
                          <td>
                            {moment(el?.joinedDate).format("DD MMMM YYYY")}
                          </td>
                          <td>{el.planName}</td>
                          <td>
                            <p
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleStatusChangeTenant(el, el.isActive);
                              }}
                            >
                              <Switch
                                onChange={(e) => {}}
                                width={30}
                                height={16}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                onColor="#F75891"
                                checked={el.isActive === 1}
                              />
                              &nbsp;&nbsp;
                              <br />
                              {el.isActive === 1 ? "Active" : "Inactive"}
                            </p>
                          </td>
                          <td className="text-center d-flex" style={{height:'72px', position:'relative', bottom:'-1px'}}>
                            <button
                              style={{
                                border: "1px solid #f75891",
                                marginRight: "5px",
                              }}
                              onClick={() => {
                                getTenantDetails(el);
                                setActionTab(true);
                              }}
                            >
                              Info
                            </button>
                            <button
                              style={{
                                border: "1px solid #f75891",
                                marginRight: "5px",
                              }}
                              onClick={() => {
                                getTenantDetails(el);
                                setAddCredits(true);
                              }}
                            >
                              Add credits
                            </button>
                            <button
                              style={{ border: "1px solid #f75891" }}
                              onClick={() => {
                                getSubscriptionPlan(el);
                              }}
                            >
                              Subscription
                            </button>
                            {/* <img
                              src="/images/info.svg"
                              alt=""
                              onClick={() => {
                                getTenantDetails(el);
                                setActionTab(true);
                              }}
                              className="pointer"
                            />
                            &nbsp;&nbsp;
                            <img
                              src="/images/add-icon.svg"
                              width={20}
                              height={20}
                              alt=""
                              className="pointer"
                              onClick={() => {
                                getTenantDetails(el);
                                setAddCredits(true);
                              }}
                            /> */}
                          </td>
                        </tr>
                      ))}
                </tbody>
              </Table>
              <Pagination
                currentPage={currentTenantPage}
                totalPages={Math.ceil(totalTenant / rows)}
                paginate={paginateTenants}
                indexOfFirst={(currentTenantPage - 1) * rows}
                indexOfLast={Math.min(currentTenantPage * rows, totalTenant)}
                total={totalTenant}
              />
            </div>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <div className="users-header">
            <h2>{t("Users", { ns: "profile" })}</h2>
            <div className="d-flex align-items-center flex-wrap">
              <div className="has-search">
                <span className="form-control-feedback">
                  <img src="/images/search.svg" alt="" width={12} />
                </span>
                <input
                  type="text"
                  className="form-control"
                  value={query}
                  placeholder={t("Search for a user", { ns: "profile" })}
                  onChange={(e) => searchUser(e.target.value)}
                />
              </div>
              &nbsp;&nbsp;
              <button className="add-btn" onClick={handleAddUsers}>
                {t("ADD USERS", { ns: "profile" })}
              </button>
            </div>
          </div>
          <div className="table-admin">
            <Table responsive className="assessment-table">
              <thead>
                <tr>
                  <th>{t("Name", { ns: "profile" })}</th>
                  <th>{t("Email", { ns: "profile" })}</th>
                  <th>{t("Role", { ns: "profile" })}</th>
                  <th>{t("Status", { ns: "profile" })}</th>
                </tr>
              </thead>
              <tbody className="table-body">
                {isUserLoading
                  ? "Loading"
                  : usersList &&
                    usersList.map((el) => (
                      <tr key={el.userID}>
                        <td>
                          <strong>{el.name}</strong>
                        </td>
                        <td>{el.emailId}</td>
                        <td>{el.roleName}</td>
                        <td>
                          <p
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleChange(el, el.isActive);
                            }}
                          >
                            <Switch
                              onChange={(e) => {}}
                              width={30}
                              height={16}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              onColor="#F75891"
                              checked={el.isActive === 1}
                            />
                            &nbsp;&nbsp;
                            <br />
                            {el.isActive === 1 ? "Active" : "Inactive"}
                          </p>
                        </td>
                      </tr>
                    ))}
              </tbody>
            </Table>
            <Pagination
              currentPage={currentUserPage}
              totalPages={Math.ceil(total / rows)}
              paginate={paginateUsers}
              indexOfFirst={(currentUserPage - 1) * rows}
              indexOfLast={Math.min(currentUserPage * rows, total)}
              total={total}
            />
          </div>
        </Fragment>
      )}

      <Modal
        show={isAddUser}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName={"add-user-modal"}
      >
        <div className="modal-header" style={{ background: "#f75891" }}>
          <h5 className="modal-title">{t("Add User")} </h5>
          <div className="sticky-close" onClick={handleModal}>
            <img src="/images/close-white.svg" width="15px" alt="" />
          </div>
        </div>
        <Modal.Body style={{ padding: "22px 40px 22px 40px" }}>
          <div>
            <label>{t("Name", { ns: "profile" })}*</label>
            <input
              className="form-control mt-2"
              value={name}
              onChange={(e) => changeName(e.target.value)}
            />
          </div>
          <small>{nameError}</small>
          <div className="mt-2">
            <label>{t("Email", { ns: "profile" })}*</label>
            <input
              className="form-control mt-2"
              value={email}
              onChange={(e) => changeEmail(e.target.value)}
            />
          </div>
          <small>{emailError}</small>
          <div className="save-btn">
            <button disabled={isLoading} onClick={saveUser}>
              {isLoading ? (t("Saving...")) : (t("Save"))}
            </button>
            <button onClick={() => handleModal()}>
              {t("Cancel", { ns: "profile" })}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {actionTab === true ? (
        <Modal
          show={isDetail}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          dialogClassName={"detail-modal"}
        >
          <div className="modal-header" style={{ background: "#f75891" }}>
            <h5 className="modal-title">{"Tenant Details"} </h5>
            <div className="sticky-close" onClick={handleModal}>
              <img
                src="/images/close-white.svg"
                width="15px"
                alt=""
                onClick={() => setActionTab(false)}
              />
            </div>
          </div>
          <Modal.Body style={{ padding: "22px" }}>
            <div className="row">
              <div className="col-md-6 col-12">
                <div>
                  <label>{t("Name", { ns: "profile" })}*</label>
                  <input
                    className="form-control mt-2"
                    value={tenantIndividualUser?.name}
                    disabled
                  />
                </div>
              </div>
              <div className="col-md-6 col-12">
                <label>{t("Email", { ns: "profile" })}*</label>
                <input
                  className="form-control mt-2"
                  value={tenantIndividualUser?.emailId}
                  disabled
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-6 col-12">
                <div className="position-relative">
                  <label>{t("Password", { ns: "profile" })}*</label>
                  <input
                    type="password"
                    className="form-control mt-2"
                    id="pass"
                    value={tenantIndividualUser?.password}
                    disabled
                  />
                  <div
                    style={{
                      position: "absolute",
                      cursor: "pointer",
                      top: 38,
                      right: 0,
                      zIndex: 1,
                    }}
                  >
                    <img
                      src="/images/copy.png"
                      alt=""
                      onClick={() => copyLink()}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <label>{t("Current Plan", { ns: "profile" })}*</label>
                <input
                  className="form-control mt-2"
                  value={tenantIndividualUser?.planName}
                  disabled
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-6 col-12 select-wrapper">
                <label>{t("Upgrade Plan", { ns: "profile" })}*</label>
                <select
                  className="form-control mt-2 custom-select"
                  value={selectedPlanId}
                  onChange={handlePlanChange}
                >
                  <option value="" disabled selected>
                    Select Plan
                  </option>
                  {subscriptionPlanList?.map((plan) => (
                    <option key={plan.planId} value={plan.planId}>
                      {plan.planName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6 col-12">
                {selectedPlanId === 10 ? (
                  <div className="position-relative">
                    <label>{t("Plan Test Credits", { ns: "profile" })}*</label>
                    <input
                      type="text"
                      className="form-control mt-2"
                      id="pass"
                      value={"Unlimited"}
                      disabled
                    />
                  </div>
                ) : tenantIndividualUser?.planId === 10 && !planTestCredits ? (
                  <div className="position-relative">
                    <label>{t("Plan Test Credits", { ns: "profile" })}*</label>
                    <input
                      type="text"
                      className="form-control mt-2"
                      id="pass"
                      value={"Unlimited"}
                      disabled
                    />
                  </div>
                ) : (
                  <div className="position-relative">
                    <label>{t("Plan Test Credits", { ns: "profile" })}*</label>
                    <input
                      type="number"
                      className="form-control mt-2"
                      id="pass"
                      value={
                        planTestCredits ?? tenantIndividualUser?.planTestCredit
                      }
                      onChange={handleTestCreditsChange}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-6 col-12">
                <label>{t("Plan Balance credit", { ns: "profile" })}*</label>
                <input
                  className="form-control mt-2"
                  value={tenantIndividualUser?.balanceCredit}
                  disabled
                />
              </div>
              <div className="col-md-6 col-12">
                <label>{t("Test taken", { ns: "profile" })}</label>
                <input
                  className="form-control mt-2"
                  value={tenantIndividualUser?.testTaken}
                  disabled
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-6 col-12">
                <label>{t("Total Invites", { ns: "profile" })}</label>
                <input
                  className="form-control mt-2"
                  value={tenantIndividualUser?.totalInvites}
                  disabled
                />
              </div>
              <div className="col-md-6 col-12">
                <label>{t("Number Of Users", { ns: "profile" })}</label>
                <input
                  className="form-control mt-2"
                  value={tenantIndividualUser?.userCount}
                  disabled
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-6 col-12">
                <label>{t("Additional Credit Left", { ns: "profile" })}</label>
                <input
                  className="form-control mt-2"
                  value={tenantIndividualUser?.additionalCreditLeftCount}
                  disabled
                />
              </div>
              <div className="col-md-6 col-12">
                <label>
                  {t("Additional Credit Valid Till Date", { ns: "profile" })}
                </label>
                <input
                  className="form-control mt-2"
                  value={moment(
                    tenantIndividualUser?.additionalCreditValidTillDate
                  ).format("DD/MM/YYYY")}
                  disabled
                />
              </div>
            </div>
            {selectedPlanId ? (
              <div className="text-center mt-4">
                <button
                  disabled={isLoading}
                  className="custom-btns"
                  onClick={() => updateSubscriptionChange()}
                >
                  {isLoading ? (
                    <div className="ballbeat">
                      <BallBeat color="#fff" />
                    </div>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            ) : null}
          </Modal.Body>
        </Modal>
      ) : null}
      {addCredits === true ? (
        <Modal
          show={isDetail}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          dialogClassName={"detail-modal"}
        >
          <div className="modal-header" style={{ background: "#f75891" }}>
            <h5 className="modal-title">{"Tenant Details"} </h5>
            <div className="sticky-close" onClick={handleModal}>
              <img
                src="/images/close-white.svg"
                width="15px"
                alt=""
                onClick={() => setAddCredits(false)}
              />
            </div>
          </div>
          <Modal.Body style={{ padding: "22px" }}>
            <div className="row mt-2">
              <div className="col-md-6 col-12">
                <label>{t("Additional Credit Left", { ns: "profile" })}</label>
                <input
                  className="form-control mt-2"
                  value={tenantIndividualUser?.additionalCreditLeftCount}
                  disabled
                />
              </div>
              <div className="col-md-6 col-12">
                <label>
                  {t("Additional Credit Valid Till Date", { ns: "profile" })}
                </label>
                <input
                  className="form-control mt-2"
                  value={
                    tenantIndividualUser?.additionalCreditValidTillDate
                      ? moment(
                          tenantIndividualUser?.additionalCreditValidTillDate
                        ).format("DD/MM/YYYY")
                      : ""
                  }
                  disabled
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-6 col-12">
                <label>{t("Add Additional Credit", { ns: "profile" })}</label>
                <input
                  className="form-control mt-2"
                  type="number"
                  min="0"
                  value={additionalCredit}
                  onChange={(e) => setAdditionalCredit(e.target.value)}
                />
              </div>
              <div className="col-md-6 col-12">
                <label>
                  {t("Add Additional Credit Valid Till Date", {
                    ns: "profile",
                  })}
                </label>
                <input
                  className="form-control mt-2"
                  type="date"
                  min={moment(
                    tenantIndividualUser?.additionalCreditValidTillDate
                  )
                    .add(1, "days")
                    .format("YYYY-MM-DD")}
                  value={validTillDate}
                  onChange={(e) => setValidTillDate(e.target.value)}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="text-center mt-4">
                <button className="custom-btns" onClick={handleAddCredits}>
                  Add Credits
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : null}
      <Modal
        show={showSuccessModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName={"detail-modal"}
      >
        <div className="modal-header" style={{ background: "#f75891" }}>
          <h5 className="modal-title">{t("Updated", { ns: "profile" })} </h5>
          <div className="sticky-close" onClick={handleSuccessModal}>
            <img src="/images/close-white.svg" width="15px" alt="" />
          </div>
        </div>
        <Modal.Body style={{ padding: "22px", textAlign: "center" }}>
          <h1>{modelMessage.includes("cannot") ? "⚠️" : "😃"}</h1>
          <h3 style={{color:'black'}}>{modelMessage}</h3>
        </Modal.Body>
      </Modal>
      <Modal
        show={subscriptionPopup}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName={"detail-modal"}
        onHide={() => {
          resetSubscriptionPopup();
          setSubscriptionPopup(false);
        }}
      >
        <div className="modal-header" style={{ background: "#f75891" }}>
          <h5 className="modal-title">Subscription Plan</h5>
          <div
            className="sticky-close"
            onClick={() => {setSubscriptionPopup(false); setIsEditingCandidateCredits(false);}}
          >
            <img src="/images/close-white.svg" width="15px" alt="" />
          </div>
        </div>
        <Modal.Body style={{ padding: "22px" }}>
          {subscriptionError ? (
            <>
              <h5 className="text-danger mb-3">
                You don’t have any subscription.
              </h5>
              <div className="row mb-3">
                <div className="col-12">
                  <label>Select a Plan</label>
                  <select
                    className="form-control"
                    value={selectedPlanIdForSubscription}
                    disabled={loading}
                    onChange={(e) => {
                      const planId = e.target.value;
                      setSelectedPlanIdForSubscription(planId);

                      const selected = availablePlans.find((p) => p.id === planId);
                      setSelectedPlan(selected);

                      if (selected?.plan_type === "usage") {
                        setCredits(selected.total_credits ?? 0);
                      } else {
                        setCredits(0);
                      }

                      const featureMap = {};
                      selected?.subscription_plan_features?.forEach((f) => {
                        const code = f.subscription_feature?.code;
                        featureMap[code] = f.limit_count ?? f.credit_count ?? 0;
                      });

                      setFeatureCounts({
                        VOICE_CALL: featureMap.VOICE_CALL || 0,
                        ASSESSMENT: featureMap.ASSESSMENT || 0,
                        VIDEO_CALL: featureMap.VIDEO_CALL || 0,
                        candidate_count: featureMap.CANDIDATE || 0,
                      });
                    }}
                  >
                    <option value="">Select Plan</option>
                    {availablePlans.map((plan) => (
                      <option key={plan.id} value={plan.id}>
                        {plan.name} ({plan.plan_type === "usage" ? "Flexible Credits" : "Fixed Credits"})
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {selectedPlan && isFixedPlan && (
                <>
                  <div className="row mt-2">
                    <div className="col-md-4 col-12">
                      <label>Voice Call Count</label>
                      <input
                        type="number"
                        className="form-control mt-2"
                        min="0"
                        value={featureCounts.VOICE_CALL}
                        onChange={(e) =>
                          handleFeatureCountChange("VOICE_CALL", e.target.value)
                        }
                        disabled={loading}
                      />
                    </div>
                    <div className="col-md-4 col-12">
                      <label>Assessment Count</label>
                      <input
                        type="number"
                        className="form-control mt-2"
                        min="0"
                        value={featureCounts.ASSESSMENT}
                        onChange={(e) =>
                          handleFeatureCountChange("ASSESSMENT", e.target.value)
                        }
                        disabled={loading}
                      />
                    </div>
                    <div className="col-md-4 col-12">
                      <label>Video Call Count</label>
                      <input
                        type="number"
                        className="form-control mt-2"
                        min="0"
                        value={featureCounts.VIDEO_CALL}
                        onChange={(e) =>
                          handleFeatureCountChange("VIDEO_CALL", e.target.value)
                        }
                        disabled={loading}
                      />
                    </div>
                    <div className="col-md-4 col-12">
                      <label>Candidate Adding Count</label>
                      <input
                        type="number"
                        className="form-control mt-2"
                        min="0"
                        value={featureCounts.candidate_count}
                        onChange={(e) =>
                          handleFeatureCountChange("candidate_count", e.target.value)
                        }
                        disabled={loading}
                      />
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <button
                      className="custom-btns"
                      onClick={() =>
                        handleAddSubscription(currentTenantForSubscription)
                      }
                      disabled={!selectedPlan || loading}
                    >
                      {loading ? "Adding..." : "Add Subscription"}
                    </button>
                  </div>
                </>
              )}
              {selectedPlan && isUsagePlan && (
                <div className="payg-wrapper">
                 <div className="row mt-2">
                    <div className="col-md-12 col-12">
                      <label>Total Credit</label>
                      <input
                        type="number"
                        className="form-control mt-2"
                        min="0"
                        value={credits}
                        onChange={(e) => setCredits(Number(e.target.value))}
                        disabled={loading}
                      />
                    </div>
                  </div>

                {/* Deductible section */}
                <h4 className="mt-3" style={{color:'#696873'}}>Deduct Quantity</h4>
                <div className="row mt-2">
                    <div className="col-md-4 col-12">
                      <label>Voice Call</label>
                      <input
                        type="number"
                        className="form-control mt-2"
                        min="0"
                        value={featureCounts.VOICE_CALL}
                        onChange={(e) =>
                          handleFeatureCountChange("VOICE_CALL", e.target.value)
                        }
                        disabled={loading}
                        readOnly
                      />
                    </div>
                    <div className="col-md-4 col-12">
                      <label>Assessment</label>
                      <input
                        type="number"
                        className="form-control mt-2"
                        min="0"
                        value={featureCounts.ASSESSMENT}
                        onChange={(e) =>
                          handleFeatureCountChange("ASSESSMENT", e.target.value)
                        }
                        disabled={loading}
                        readOnly
                      />
                    </div>
                    <div className="col-md-4 col-12">
                      <label>Video Call</label>
                      <input
                        type="number"
                        className="form-control mt-2"
                        min="0"
                        value={featureCounts.VIDEO_CALL}
                        onChange={(e) =>
                          handleFeatureCountChange("VIDEO_CALL", e.target.value)
                        }
                        disabled={loading}
                        readOnly
                      />
                    </div>
                    <div className="col-md-4 col-12">
                      <label>Candidate</label>
                      <input
                        type="number"
                        className="form-control mt-2"
                        min="0"
                        value={featureCounts.candidate_count}
                        onChange={(e) =>
                          handleFeatureCountChange("candidate_count", e.target.value)
                        }
                        disabled={loading}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <button
                      className="custom-btns"
                      onClick={() =>
                        handleAddSubscription(currentTenantForSubscription)
                      }
                      disabled={!selectedPlan || loading}
                    >
                      {loading ? "Adding..." : "Add Subscription"}
                    </button>
                  </div>

              </div>
              )}
            </>
          ) : (
            <>
              <div className="row mt-2">
                <div className="col-md-6 col-12">
                  <label>Current Plan </label>
                  <input
                    className="form-control mt-2"
                    value={selectedTenant?.data?.subscription_plan?.description}
                    disabled
                  />
                </div>
                <div className="col-md-6 col-12">
                  <label>Expires at</label>
                  <input
                    className="form-control mt-2"
                    value={selectedTenant?.data?.ends_at?.split("T")[0] || ""}
                    disabled
                  />
                </div>
              </div>
              {isUsageCurrentPlan ? (
                <>
                  {/* TOTAL CREDITS */}
                  <div className="row mt-3">
                    <div className="col-md-6 col-12">
                      <label>Total Credits</label>
                      <input
                        className="form-control mt-2"
                        value={selectedTenant?.data?.total_credits ?? 0}
                        disabled
                      />
                    </div>
                  </div>

                  {/* DEDUCT QUANTITY */}
                  <h4 className="mt-4" style={{ color: "#696873" }}>
                    Deduct Quantity
                  </h4>

                  <div className="row mt-2">
                    {["VOICE_CALL", "ASSESSMENT", "VIDEO_CALL", "CANDIDATE"].map(
                      (featureCode) => {
                        const usage = selectedTenant?.data?.feature_usages?.find(
                          (u) => u.subscription_feature?.code === featureCode
                        );

                        const labelMap = {
                          VOICE_CALL: "Voice Call",
                          ASSESSMENT: "Assessment",
                          VIDEO_CALL: "Video Call",
                          CANDIDATE: "Candidate",
                        };

                        return (
                          <div className="col-md-6 col-12 mt-3" key={featureCode}>
                            <label>{labelMap[featureCode]} (Used Credits)</label>
                            <input
                              className="form-control mt-2"
                              value={usage?.used_credits ?? 0}
                              disabled
                            />
                          </div>
                        );
                      }
                    )}
                  </div>
                </>
              ) : (
                <>
                {["VOICE_CALL", "ASSESSMENT", "VIDEO_CALL", "CANDIDATE"].map((featureCode) => {
                  const usage = selectedTenant?.data?.feature_usages?.find(
                    (u) => u.subscription_feature?.code === featureCode
                  );
                  const labelMap = {
                    VOICE_CALL: "Voice Call Credits",
                    ASSESSMENT: "Assessment Credits",
                    VIDEO_CALL: "Video Call Credits",
                    CANDIDATE: 'Candidate Credits',
                  };

                  return (
                    <div className="row mt-3" key={featureCode}>
                      <h4>{labelMap[featureCode]}</h4>
                      {featureCode === "CANDIDATE" ? (
                        <div className="col-md-4 col-12">
                          <div className="d-flex" style={{marginBottom:'12px'}}>
                            <label>Total Credits</label>
                            {!isEditingCandidateCredits && (
                              <img
                                src="/images/edit-icon.svg"
                                alt="edit"
                                onClick={() => {
                                  setCandidateCreditInput(usage?.total_count ?? 0);
                                  setIsEditingCandidateCredits(true);
                                }}
                              />
                            )}
                          </div>
                          <input
                            className="form-control mt-2"
                            type="number"
                            value={
                              isEditingCandidateCredits
                                ? candidateCreditInput
                                : usage?.total_count ?? 0
                            }
                            disabled={!isEditingCandidateCredits}
                            onChange={(e) => setCandidateCreditInput(e.target.value)}
                          />
                        </div>
                      ) : (
                        <div className="col-md-4 col-12">
                          <label>Total Credits</label>
                          <input className="form-control mt-2" value={usage?.total_count ?? 0} disabled />
                        </div>
                      )}
                      <div className="col-md-4 col-12">
                        <label>Remaining Credits</label>
                        <input
                          className="form-control mt-2"
                          value={usage?.remaining_count ?? 0}
                          disabled
                        />
                      </div>
                      <div className="col-md-4 col-12">
                        <label>Used Credits</label>
                        <input
                          className="form-control mt-2"
                          value={usage?.used_count ?? 0}
                          disabled
                        />
                      </div>
                      {featureCode === "CANDIDATE" && isEditingCandidateCredits && (
                        <div className="col-12 mt-3">
                          <button
                            className="custom-btns"
                            onClick={() =>
                              handleCandidateCreditsSave(
                                selectedTenant?.data?.id,
                                candidateCreditInput
                              )
                            }
                          >
                            Save
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
      {loading && (
        <div className="gp-loader-container">
          <div className="gp-loader"></div>
        </div>
      )}
    </div>
  );
}
